import React, { lazy, Suspense, Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Layout from "./hoc/Layout/Layout";
// import Logout from "./containers/Auth/Logout/Logout";
import Aux1 from "./hoc/Aux1/Aux1";
import * as actions from "./store/actions/index";
import CacheBuster from "react-cache-buster";
import packageInfo from "../package.json";
import Spinner from "./components/UI/Spinner/Spinner";
// import "react-multi-carousel/lib/styles.css";
// import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/css/common.scss";
import "./styles/css/responsive.css";
import "./App.css";
// import "./AppEdit.css";
import "./styles/css/responsive.css";
import ReactGA from "react-ga4";
import packageJson from "../package.json";
import { ReactLenis, useLenis } from "lenis/react";
global.appVersion = packageJson.version;

const Logout = lazy(() => import("./containers/Auth/Logout/Logout"));
const Landingpage = lazy(() => import("./components/Landingpage/Landingpage"));
const Room = lazy(() => import("./components/Room/Room"));
const Explore = lazy(() => import("./components/Explore/Explore"));
const About = lazy(() => import("./components/About/About"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Launch = lazy(() => import("./components/Launch/Launch"));
const Login = lazy(() => import("./components/Launch/Login"));
const MainLogin = lazy(() => import("./containers/Auth/Auth"));
const Booking = lazy(() => import("./components/Booking/Booking"));
const Favourites = lazy(() => import("./components/Favourites/Favourites"));
const Roomtype = lazy(() => import("./components/Roomtype/Roomtype"));
const Profile = lazy(() => import("./components/Profile/Profile"));
const Receipt = lazy(() => import("./components/Receipt/Receipt"));
const PG = lazy(() => import("./components/PG/PG"));
const TRACKING_ID = "";
// ReactGA.initialize(TRACKING_ID);
const windowUrl = window.location.hash;

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
    if (localStorage.itstoken !== "" && localStorage.itstoken !== undefined) {
      this.props.onOneLoginSignup();
    }
  }

  render() {
    let routes = (
      <Suspense fallback={<Spinner></Spinner>}>
        <Switch>
          <Route path="/" exact component={PG} />
          <Route path="/istifada" exact component={PG} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
        </Switch>
      </Suspense>
    );
    return (
      <Aux1>
        <CacheBuster
          currentVersion={packageInfo.version}
          isEnabled={true} //If false, the library is disabled.
          isVerboseMode={false} //If true, the library writes verbose logs to console.
          loadingComponent={<Spinner></Spinner>}
          metaFileDirectory={"."}
        >
          <div className="App">
            <ReactLenis root>
              <Layout>{routes}</Layout>
            </ReactLenis>
          </div>
        </CacheBuster>
      </Aux1>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    onOneLoginSignup: () => dispatch(actions.authCheckOneLogin()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
